<template>
  <div class="col-md-7 col-lg-8 wrapper-rounded-content content-mybookings">
    <div class="bg-blue-multiply rounded-corners"></div>

    <div class="row justify-content-center headinline">
      <div class="col-md-12">
        <h1 class="d-inline-block">{{ $t("Reservation") }}</h1>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">{{ $t("Datum") }}</th>
                <th scope="col">{{ $t("Fahrzeug") }}</th>
                <th scope="col">{{ $t("Station") }}</th>
                <th scope="col">{{ $t("Aktion") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="res in reservations"
                :class="'status--' + res.reservation.status"
                v-if="res.reservation.invoiced != 1"
              >
                <td>
                  {{
                    formatter.OUTPUT_DATE_ONLY_DATE(res.reservation.startdate)
                  }}
                </td>
                <td>{{ res.vehicle.vehicle_description }}</td>
                <td>
                  {{
                    $store.getters["orm/station"](res.reservation.station).name
                  }}
                </td>
                <td>
                  <!--<a href="#">{{ $t("GLOBAL.GLOBAL.ORDER_STATUS_ABGESCHLOSSEN") }}</a>-->
                  <router-link
                    v-if="!res.reservation.endtime_real"
                    :to="{
                      name: 'PageMybookingdetails',
                      params: { result: res },
                    }"
                    ><a href="#">{{ $t("Details") }}</a></router-link
                  >
                  <router-link
                    v-else
                    :to="{
                      name: 'PageMybookingdetails',
                      params: { result: res },
                    }"
                    ><a href="#" class="booking-old">{{
                      $t("GLOBAL.GLOBAL.ORDER_STATUS_ABGESCHLOSSEN")
                    }}</a></router-link
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <div class="booking-old" v-if="reservations.length <= 0">
            <td>{{ $t("Keine Reservierung im System") }}</td>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
	 *  {{ $t("GLOBAL.GLOBAL.ORDER_STATUS_ABGERECHNET") }}
		{{ $t("GLOBAL.GLOBAL.ORDER_STATUS_ABGESCHLOSSEN") }}
		{{ $t("GLOBAL.GLOBAL.ORDER_STATUS_IN_RENT") }}
		{{ $t("GLOBAL.GLOBAL.ORDER_STATUS_RESERVIERUNG") }}
		{{ $t("GLOBAL.GLOBAL.ORDER_STATUS_STORNIERT") }}
	 */
import formatter from "@/store/orm/helpers/formater";
import { mapGetters } from "vuex";

export default {
  name: "PageMybookings",
  computed: {
    ...mapGetters("orm/reservation", {
      user_session: "user_session",
    }),

    ...mapGetters("orm", {
      resGroups: "groups",
      resGroup: "group",
      resStation: "station",
    }),
  },
  data() {
    return {
      formatter,
      reservations: [],
    };
  },
  async mounted() {
    var self = this;

    await this.$store
      .dispatch("orm/GET_STATIONS")
      .then((cities) => {
        self.$store.dispatch("orm/GET_GROUPS");
      })
      .catch((err) => {
        this.$store.commit("core/ADD_ERROR", err);
      });
    this.$emit("isActive", "bookings");
    this.$store
      .dispatch("orm/GET_CUSTOMER_RESERVATION")
      .then((result) => {
        self.reservations = result.result;
      })
      .catch((err) => {
        this.$store.commit("core/ADD_ERROR", err);
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/PageMybookings.vue